export default __webpack_public_path__ + "static/media/online-tick.e65eab82.svg";